import {
	commonAzureDurableRequest,
	getApiDomain,
} from './curriculum-azure-functions'

// ---------------------------------------------------------------------------
// Full List tab — POST /api/PrescriptionsListPrintTrigger
// Path: NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_LIST_PRINT
// ---------------------------------------------------------------------------

export interface IGetPrescriptionListDocsParams {
	listcodename: string
	pdf?: boolean
	isPreviewMode?: boolean
}

export async function getPrescriptionListDocs(
	params: IGetPrescriptionListDocsParams,
	abortSignal?: AbortSignal,
) {
	return await commonAzureDurableRequest<IGetPrescriptionListDocsParams>(
		getApiDomain(params.isPreviewMode) +
			process.env.NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_LIST_PRINT,
		{
			listcodename: params.listcodename,
			pdf: params.pdf ?? false,
			isPreviewMode: params.isPreviewMode,
		},
		abortSignal,
		params.isPreviewMode,
	)
}

import type { PrescriptionPrintPayload } from '@/components/prescriptions/utils/buildPrescriptionPrintPayload'

export interface IGetPrescriptionSelectionDocsParams {
	payload: PrescriptionPrintPayload
	isPreviewMode?: boolean
}

type PrescriptionSelectionPrintRequestBody = PrescriptionPrintPayload & {
	isPreviewMode?: never
}

export async function getPrescriptionSelectionDocs(
	params: IGetPrescriptionSelectionDocsParams,
	abortSignal?: AbortSignal,
) {
	return await commonAzureDurableRequest<PrescriptionSelectionPrintRequestBody>(
		getApiDomain(params.isPreviewMode) +
			process.env.NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_SELECTION_PRINT,
		params.payload as PrescriptionSelectionPrintRequestBody,
		abortSignal,
		params.isPreviewMode,
	)
}

export default getPrescriptionListDocs
